var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"table"},[_vm._m(0),_c('tbody',_vm._l((_vm.vendors),function(v,vi){return _c('tr',{key:vi},[_c('td',[_vm._v(_vm._s(v.name))])])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Vendor List")])])])
}]

export { render, staticRenderFns }